<template>
  <div>
    <!-- Overview -->
    <a-row id="star-chaser" type="flex" justify="space-around" align="top">
      <a-col :sm="{span: 12}" :lg="{span: 8}">
        <h1>Star Chaser</h1>
        <p>
          An experienced explorer is sent into the vast space to find all kind of minerals and life species.
          Unfortunately he gets trapped in a asteroids ring wich is used as garbage disposal
        </p>
        <p>Your mission is to help him to scape and help him avoid all this obstacles and survive this asteroids hell.</p>
        <p><a href="https://play.google.com/store/apps/details?id=com.fireboundsoft.star.chaser" target="_blank" rel="noopener noreferrer">Download game</a></p>
      </a-col>
      <a-col :sm="{span: 12}" :lg="{span: 10}">
        <img src="https://lh3.googleusercontent.com/FZkpmXOaUMkqI3ulveknm-78Dx5lEFSPFxgu4R3zHNc_e8NFQ2332oa25zz4EwsQ8LA=w1366-h641-rw" alt="star chaser" class="game-image" />
      </a-col>
    </a-row>

    <!-- image gallery -->
    <a-carousel autoplay id="gallery-container">
      <div>
        <img src="https://lh3.googleusercontent.com/IhrL9TDfk_z8EcIp5p1BwJoZirVi32_KrpV2o6DwGrGWGmSLAP6EtUPpaYm0sOtaFCM=w1366-h556-rw" class="img-gallery" />
      </div>
      <div>
        <img src="@/assets/images/starchaser/unlockables.png" class="img-gallery" />
      </div>
    </a-carousel>

    <!-- posts about game -->

    <div class="posts">
      <h1>Devlog</h1>
      <div class="loading-container" v-if="loading">
        <a-spin />
      </div>

      <a-row :gutter="16" v-for="post in posts" :key="post.title" v-else>
        <a-divider class="content" orientation="left">{{post.created_at.fromNow()}}</a-divider>

        <router-link :to="'/devlog/post/'+post.id" class="blog-post-row">
          <a-col :sm="{span: 12}" :lg="{span: 6}">
            <a-card :ref="'post-card'+post.id">
              <img src :id="post.id" slot="cover" alt class />
            </a-card>
          </a-col>
          <a-col :sm="{span: 12}" :lg="{span: 10}">
            <span class="game-title">{{post.game}}</span>
            <h1>{{post.title}}</h1>
            <p>{{post.details}}</p>
          </a-col>
        </router-link>
      </a-row>
    </div>
  </div>
</template>

<script>
import firebase from "@/configs/firebase-setup";
import moment from "moment";
const db = firebase.firestore();
const storage = firebase.storage().ref();

export default {
  data() {
    return {
      loading: false,
      posts: []
    };
  },

  mounted() {
    this.getPosts();
  },

  updated() {
    this.posts.forEach(post => {
      this.getPostImgURL(post.id);
    });
  },

  methods: {
    async getPosts() {
      try {
        this.loading = true;

        const snapshot = await db
          .collection("posts")
          .where("game", "==", "Star Chaser")
          .orderBy("created_at", "desc")
          .get();

        snapshot.forEach(doc => {
          const data = doc.data();

          if (data.publishDate == null) {
            return;
          }

          data.id = doc.id;
          data.created_at = moment(data.created_at);

          this.posts.push(data);
        });

        this.posts.sort((a, b) => {
          return a.created_at;
        });

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    getPostImgURL(postId) {
      storage
        .child(`images/posts/${postId}/${postId}`)
        .getDownloadURL()
        .then(url => {
          const img = document.getElementById(postId);
          img.src = url;
        })
        .catch(err => {
          console.log(err);
          return "";
        });
    }
  }
};
</script>

<style scoped>
.game-image {
  width: 100%;
  max-width: 700px;
  max-height: 500px;
}

#gallery-container {
  width: 70%;
  margin: 2em auto;
}

.ant-carousel >>> .slick-dots {
  height: auto;
}

.ant-carousel >>> .slick-slide {
  text-align: center;
  overflow: hidden;
}

.img-gallery {
  margin: 0 auto;
  max-width: 100%;
  max-height: 400px;
  width: auto;
  height: auto;
}

.blog-post-row {
  color: #383838;
}

.posts {
  padding: 0 50px 30px 50px;
  font-family: "ZCOOL QingKe HuangYou", cursive;
  font-size: 1.2em;
}

.game-title {
  color: #afaeae;
  font-weight: bold;
  text-transform: uppercase;
}
</style>